import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import LocationNavigation from "@components/Locations/location-navigation";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { clientGetVendor } from "@services/vendors.service";
import { getValue } from "@utils/lodash";
import Notfound from "@components/Not-Found";
import { toast } from "react-toastify";
import {
	clientGetLocationAttachedVendors,
	clientUpdateLocationVendor,
} from "@services/location.service";
import Loader from "@components/common/Loader";
import PaginationPage from "@components/pagination/pagination";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import React from "react";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import DeleteModal from "@_common/deleteModal";
import { sanitizeInput } from "@_common/dompurify";
import { NavLink } from "react-router-dom";


export default function MapVendor(props: any) {
	let params = useParams();
	let navigate = useNavigate();
	const urlSearchParams = new URLSearchParams(window.location.search);
	const urlParams = Object.fromEntries(urlSearchParams.entries());
  

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [vendorsList, setVendorsList] = useState([]);
	const [subVendorList, setSubVendorList] = useState([]);

	const [selectedVendor, setSelectedVendor] = useState("");

	const [selectedSubVendor, setSelectedSubVendor] = useState<any>([]);

	const [isLoading1, setIsLoading1] = useState(true);
	const [isLoading2, setIsLoading2] = useState(false);

	// const [attachedVendors, setAttachedVendors] = useState([]);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
			getVendorList();
			getAttachedVendors();
		}
	}, [props.permissionAPITriggered]);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
			if (params.page_no) {
				setPage_no(parseInt(params.page_no));
			}
			if (params.limit) {
				setLimit(parseInt(params.limit));
			}
			if (params.search_text) {
				setSearchInput(params.search_text);
				setShowSearchTextbox(true);
			}
			getVendorList();
			getAttachedVendors();
		}
	}, [window.location.href, props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */
	const [isLoading, setIsLoading] = React.useState(true);

	const getAttachedVendors = async () => {
		try {
			setIsLoading(true);

			let resp = await clientGetLocationAttachedVendors(params.id);
			if (resp) {
				setIsLoading(false);

				let list = getValue(resp, `data.vendors.vendor`, []).map(
					(item: object) => getValue(item, `id`, "")
				);
				setSelectedSubVendor(getValue(resp, `data.vendors.vendor`, []));
			} else {
				setSelectedSubVendor([]);
				setSubVendorList([]);
				setVendorsList([]);
			}
		} catch (error) {
			setIsLoading(false);

			setSelectedSubVendor([]);
			setVendorsList([]);
			setSubVendorList([]);
		}
	};

	const getVendorList = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		let payload: any = {
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: params.limit ? params.limit : limit,
			search_text: params.search_text,
			sort_by: params.sort_by,
			vendor_type: params.vendor_type ? params.vendor_type : "SERVICING_VENDOR",
			// is_active: true,
			// is_default: true,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			setIsLoading1(true);
			let resp = await clientGetVendor(queryRequest);
			if (resp) {
				// let filtered = getValue(resp, `data.vendors`, []).filter(
				// 	(item: object) => getValue(item, `is_active`, false)
				// 	// && getValue(item,`vendor_type`,'') !== 'SERVICING_VENDOR'
				// );

				// if (getValue(filtered, `length`, 0) > 0) {
				// 	setVendorsList(getValue(filtered, `length`, 0) > 0 ? filtered : []);
				// 	if (getValue(filtered, `[${0}].parent_id`, "")) {
				// 		getSubVendorList(getValue(filtered, `[${0}].parent_id`, ""));
				// 	}
				// 	setSelectedVendor(getValue(filtered, `[${0}].parent_id`, ""));
				// 	setTotalCount(getValue(resp, `data.pagination.total`, ""));
				// } else {
				// 	setSelectedSubVendor([]);
				// 	setVendorsList([]);
				// 	setSubVendorList([]);
				// }
				setVendorsList(
					getValue(resp, `data.vendors`, []).map((item: any) => ({
					  ...item,
					  value: getValue(item, `vendor_name`, ""),
					  label: getValue(item, `vendor_name`, ""),
		  
					})))

        setIsLoading1(false);
			} else {
				setIsLoading1(false);
				setSelectedSubVendor([]);
				setVendorsList([]);
				setSubVendorList([]);
			}
		} catch (error) {
			setIsLoading1(false);
			setSelectedSubVendor([]);
			setVendorsList([]);
			setSubVendorList([]);
		}
	};

	const handleTriggerAPI = async (value: string) => {
		let payload: any = {
		  page_no: 1,
		  page_size: 10,
		  is_active: true,
		  search_text: value,
		  vendor_type: params.vendor_type ? params.vendor_type : "SERVICING_VENDOR",
		};
		setSearchLoading(true);
		let queryRequest = QueryRequestHelper(payload);
		try {
		//   let resp = await clientGetLocation(queryRequest);
		let resp = await clientGetVendor(queryRequest);
		if (resp) {
			setVendorsList(
			getValue(resp, `data.vendors`, []).map((item: any) => ({
				...item,
				value: getValue(item, `vendor_name`, ""),
				label: getValue(item, `vendor_name`, ""),
	
			})))
			setSelectedValue({});
			setSearchLoading(false);
		  } else {
			setSearchLoading(false);
		  }
		} catch (error) {
		  setSearchLoading(false);
		}
	  };
	const getSubVendorList = async (id: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		let payload: any = {
			// page_no: params.page_no ? parseInt(params.page_no) : 1,
			// page_size: params.limit ? parseInt(params.limit) : limit,
			page_no: 1,
			page_size: 100,
			search_text: params.search_text,
			sort_by: params.sort_by,
			vendor_type: params.vendor_type ? params.vendor_type : "SERVICING_VENDOR",
			parent_id: id,
			// is_active: true,
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			setIsLoading2(true);
			let resp = await clientGetVendor(queryRequest);
			if (resp) {
				setIsLoading2(false);
				setSubVendorList(getValue(resp, `data.vendors`, []));
			} else {
				setIsLoading2(false);
				setSubVendorList([]);
			}
		} catch (error) {
			setIsLoading2(false);
			setSubVendorList([]);
		}
	};

	const handleSubmit = async (payload: object) => {
		if (selectedSubVendor.length > 0) {
			// let payload = {
			// 	append: true,
			// 	vendor_ids: selectedSubVendor,
			// };
			let resp = await clientUpdateLocationVendor(params.id, payload);
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				getAttachedVendors();
			}
		} else {
			toast.error("Please select sub vendor");
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleChangeText = (id: string) => {
		setSelectedVendor(id);
		getSubVendorList(id);
		setSelectedSubVendor([]);
		getAttachedVendors();
		setAll("false");
	};

	const handleChangeVendor = (id: string) => {
		let selected = selectedSubVendor.filter((item: string) => item === id);
		if (getValue(selected, `length`, 0) == 0) {
			selectedSubVendor.push(id);
			setSelectedSubVendor([...selectedSubVendor]);
			handleSubmit({
				append: true,
				vendor_ids: [id],
			});
		} else {
			let selected = selectedSubVendor.filter((item: string) => item !== id);
			setSelectedSubVendor(selected);
			handleSubmit({
				append: false,
				vendor_ids: [id],
			});
		}
	};
	const [all, setAll] = useState("false");
	const handleChangeAllVendor = (value: string) => {
		setAll(value);
		if (value === "true") {
			let list = subVendorList.map((item: object) => getValue(item, `id`, ""));
			setSelectedSubVendor(list);
		} else {
			setSelectedSubVendor([]);
		}
	};
	/* -------------------------------------------------------------------------- */
	/*                               Pagination section                           */
	/* -------------------------------------------------------------------------- */

	const [totalCount, setTotalCount] = useState(0);
	const [limit, setLimit] = useState(100);
	const [page_no, setPage_no] = useState(1);

	const handleChangePagination = (page_no: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload = {
			...params,
			page_no: page_no,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleChangeLimit = (limit: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			...params,
			limit: limit,
			page_no: "1",
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};
	/* -------------------------------------------------------------------------- */
	/*                               Search section                               */
	/* -------------------------------------------------------------------------- */
	const [showSearchTextbox, setShowSearchTextbox] = useState(false);
	const [search_text, setSearchInput] = useState<any>("");

	const toggleSearch = () => {
		setShowSearchTextbox((prevState) => !prevState);
	};
	const toggleSearchClose = () => {
		setSearchInput("");
		toggleSearch();
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (params.search_text) {
			delete params.search_text;
			let payload: any = { ...params };
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			getVendorList();
		}
	};

	const handleChangeSearch = async (e: any) => {
		if (e.target.value) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			setSearchInput(sanitizeInput(e.target.value));

			params.search_text = sanitizeInput(e.target.value);
			params.page_no = "1"
			// let payload: any = { ...params };

			// removing null values
			// Object.keys(payload).forEach((key) => {
			// 	if (!payload[key] || payload[key] === undefined) {
			// 		delete payload[key];
			// 	}
			// });
			let queryRequest = QueryRequestHelper(params);
			navigate(`${window.location.pathname}?${queryRequest}`);
			if (!e.target.value) {
				getVendorList();
			}
		} else {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			setSearchInput(e.target.value);
			delete params.search_text;
			let queryRequest = QueryRequestHelper(params);
			navigate(`${window.location.pathname}?${queryRequest}`);
			if (!e.target.value) {
				getVendorList();
			}
		}
	};

	/* -------------------------------------------------------------------------- */
  	/*                      New Location Search Section                           */
  	/* -------------------------------------------------------------------------- */
	  const [selectedLocation, setSelectedLocation] = useState<any>("");

	  const handleAdd = async (value: object) => {
		setSelectedLocation(value);
		let selected = selectedSubVendor.filter((item: string) => item === getValue(value,`id`,""));
		if (getValue(selected, `length`, 0) == 0) {
			selectedSubVendor.push(getValue(value,`id`,""));
			setSelectedSubVendor([...selectedSubVendor]);
			handleSubmit({
				append: true,
				vendor_ids: [getValue(value,`id`,"")],
			});
		} else {
			let selected = selectedSubVendor.filter((item: string) => item !== getValue(value,`id`,""));
			setSelectedSubVendor(selected);
			handleSubmit({
				append: false,
				vendor_ids: [getValue(value,`id`,"")],
			});
		}


	  };
	
  const [selectedValue, setSelectedValue] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);

  const handleClick = (e: any) => {
    setSelectedValue(e);
    handleAdd(e);
  };

    /* ---------------------Column Section------------------------------*/
    const columns = React.useMemo(
		() => [
		  
		  {
			Header: () => (
			  <div>
				Vendor
			  </div>
			),   
			accessor: "vendor_name",
			width: 300,
			Cell: ({ row }: any) => {
				console.log(row, "===row===")
			  return (
				<div>
				  {/* <div><b>{getValue(row,`original.vendor_name`,"")}</b></div> */}
				  	<NavLink to={`/configuration/vendors/detail-info/profile/${getValue(row,`original.parent_id`,"")}/${getValue(row,`original.id`,"")}`}>
                  		<b>{getValue(row,`original.vendor_name`,"")}</b>
					</NavLink>
				</div>
			  );
			},    
		  },
		  {
			Header: "Vendor Code",
			accessor: "vendor_code",
			width: 150,
			Cell: ({ row }: any) => {
				return (
				  <div>
					<div><b>{getValue(row,`original.vendor_code`,"")}</b></div>
				  </div>
				);
			  },  
		  },
		  {
			Header: "Status",
			accessor: "is_active",
			width: 150,
			Cell: ({ value }: { value: boolean }) => { // Explicitly type 'value' as boolean
			  return value ? "Active" : "Inactive";
			},
		  },
			{
			  Header: "Action",
			  width: 90,
			  Cell: ({ row }: any) => {
				return (
				  <div className="d-flex align-items-center justify-content-center">
					<img
					  onClick={() =>
						handleDeleteFun(
						  getValue(row, `original.id`, ""),
						  getValue(row, `original.location_name`, "")
						)
					  }
					  src="/images/list-management/country/delete-icon.svg"
					  className="img-fluid"
					  style={{ height: "24px", width: "24px" }}
					/>
				  </div>
				);
			  },
			},
		],
		[]
	  );
  
	  const [selectedIDs, setSelectedIDs] = useState<any>([]);
	  const getTableState = (value: object) => {
		let selectedIndexList = Object.keys(
		  getValue(value, `selectedRowIds`, {})
		).map((item) => parseInt(item));
		let selectedIds =
		selectedSubVendor.length > 0
			? selectedSubVendor.filter((_item: object, index: number) =>
				selectedIndexList.includes(index)
			  )
			: [];
		if (selectedIds.length > 0) {
		  setSelectedIDs(
			selectedIds.map((item: object) => getValue(item, `id`, ""))
		  );
		} else {
		  setSelectedIDs([]);
		}
	  };
	  const rowClick = (obj: object) => {
  
	  };
	  const [check, setCheck] = useState(false);
	  const handleRemoveNavItems = () => {
		setCheck(!check);
		setSelectedIDs([]);
	  };
	  const getTrProps = (rowInfo: any) => {
		if (getValue(rowInfo, `id`, "")) {
		  return {
			// style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
		  };
		}
		return {};
	  };
  

	   /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
		let payload = {
			append: false,
			vendor_ids: [deleteId],
		};
			let resp = await clientUpdateLocationVendor(params.id, payload);
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				getVendorList();
				getAttachedVendors();
				handleDelete();
				handleTriggerAPI(params.search_text);
			}

    } catch (error) {}
  };
	return (
		<>
			<Layout>
				<LocationNavigation id={params.id} />
				{!isLoading1 &&
				!getValue(props, `subTabPermissionList`, []).includes(
					"configuration_location"
				) ? (
					<NoAccessPage />
				) : (
					<>
						<div className="map-vendor-wrapper w-100 mt-3 pt-5 d-none">
							<div className="map-vendor__details d-flex align-items-flex-start">
								<div className="map-vendor__search">
									<div className="map-vendor__search-form mb-3 position-relative">
										<img
											src="/images/search.svg"
											className="img-fluid map-vendor__search-icon position-absolute"
										/>
										<input
											type="text"
											placeholder="Search"
											className="form-control"
											value={search_text}
											onChange={handleChangeSearch}
											autoComplete="off"
										/>
									</div>
									<div>
										<h5 className="map-vendor__search-title">Vendor Name</h5>
										{isLoading1 ? (
											<Loader />
										) : getValue(vendorsList, `length`, 0) > 0 ? (
											vendorsList.map((searchObj, index) => {
												return (
													<>
														<div className="position-relative">
															<input
																type="radio"
																id={`search${index}`}
																name="vendor-name"
																checked={
																	getValue(searchObj, `parent_id`, "") ===
																	selectedVendor
																}
																className="d-none custom-radio-button-input map-vendor__selected-vendor-radio-button"
																onChange={() =>
																	handleChangeText(
																		getValue(searchObj, `parent_id`, "")
																	)
																}
															/>
															<div className="map-vendor__radio-button radio-wrapper d-flex position-absolute">
																<div className="custom-radio"></div>
															</div>
															<label
																className="map-vendor__form-group d-flex align-items-center cursor-pointer transition"
																key={`search${index}`}
																htmlFor={`search${index}`}
															>
																<div className="map-vendor__label">
																	<h5 className="map-vendor__form-title">
																		{getValue(searchObj, `vendor_name`, "")}
																	</h5>
																	<p className="map-vendor__form-text">
																		{/* {`${searchObj.memberCount} Vendors`}{" "} */}
																	</p>
																</div>
															</label>
														</div>
													</>
												);
											})
										) : (
											<>
												{Object.keys(params).length !== 0 ? (
													<>
														<Notfound />
													</>
												) : (
													<Notfound />
												)}
											</>
										)}
									</div>
									<div className="footer-wrapper d-flex justify-content-between">
										{/* {vendorsList.length > 0 && (
									<img
										src="/images/building-illustration.svg"
										className="img-fluid"
									/>
								)} */}
										{totalCount > 10 ? (
											<PaginationPage
												totalCount={totalCount}
												limit={limit}
												pageNumber={page_no}
												handleChangePagination={handleChangePagination}
												handleChangeLimit={handleChangeLimit}
											/>
										) : (
											<p className="show-rows-count mt-3 d-flex">
												Total Count:&nbsp;&nbsp;{" "}
												<p style={{ color: "rgb(13, 110, 253)" }}>
													{totalCount}
												</p>
											</p>
										)}
									</div>
								</div>
								<div className="map-vendor__check">
									{getValue(subVendorList, `length`, 0) > 0 && (
										<div className="form-group d-flex">
											<label
												className="m-0 position-relative d-flex align-items-center cursor-pointer"
												htmlFor="header-checkbox"
											>
												<div>
													{getValue(props, `permissions`, []).includes(
														"update"
													) && (
														<>
															<input
																type="checkbox"
																className="default-checkbox"
																id="header-checkbox"
																onChange={() =>
																	handleChangeVendor(
																		getValue(subVendorList, `[${0}].id`, "")
																	)
																}
																checked={selectedSubVendor.includes(
																	getValue(subVendorList, `[${0}].id`, "")
																)}
															/>
															<div className="custom-checkbox">
																<img
																	src="/images/uploaded-details/tick.svg"
																	className="img-fluid uploaded-tick"
																/>
															</div>
														</>
													)}
												</div>
												<p className="mx-3">
													{getValue(subVendorList, `[${0}].vendor_name`, "")}
												</p>
											</label>
										</div>
									)}
									<div className="map-vendor__sub-vendor d-flex align-items-center justify-content-between py-2">
										<h5 className="map-vendor__search-title p-0 m-0">
											Sub-Vendor
										</h5>
										<div className="form-group d-flex align-iems-center m-0">
											<label
												className="m-0 position-relative d-flex align-items-center cursor-pointer"
												htmlFor="header-checkbox-select-all"
											>
												{/* <div>
											<input
												type="checkbox"
												className="default-checkbox"
												id="header-checkbox-select-all"
												checked={all !== "true" ? false : true}
												onChange={() =>
													handleChangeAllVendor(
														all == "true" ? "false" : "true"
													)
												}
											/>
											<div className="custom-checkbox">
												<img
													src="/images/uploaded-details/tick.svg"
													className="img-fluid uploaded-tick"
												/>
											</div>
										</div>
										<p className="mx-3">Select All</p> */}
											</label>
										</div>
									</div>
									<div className="map-vendor__checklist my-3">
										{isLoading2 ? (
											<Loader />
										) : getValue(subVendorList, `length`, 0) > 1 ? (
											subVendorList.map((searchObj, index) => {
												if (index !== 0)
													return (
														<>
															<label
																className="position-relative form-group d-flex align-items-center cursor-pointer"
																htmlFor={`sub-vendor-${index}`}
																key={`sub-vendor-${index}`}
															>
																<div>
																	{getValue(props, `permissions`, []).includes(
																		"update"
																	) && (
																		<>
																			<input
																				type="checkbox"
																				className="default-checkbox"
																				id={`sub-vendor-${index}`}
																				onChange={() =>
																					handleChangeVendor(
																						getValue(searchObj, `id`, "")
																					)
																				}
																				checked={selectedSubVendor.includes(
																					getValue(searchObj, `id`, "")
																				)}
																				name="sub-vendor"
																			/>
																			<div className="custom-checkbox">
																				<img
																					src="/images/uploaded-details/tick.svg"
																					className="img-fluid uploaded-tick"
																				/>
																			</div>
																		</>
																	)}
																</div>
																<p className="mx-3">
																	{" "}
																	{getValue(searchObj, `vendor_name`, "")}
																</p>
															</label>
														</>
													);
											})
										) : (
											<>
												{Object.keys(params).length !== 0 ? (
													<>
														<Notfound />
													</>
												) : (
													<Notfound />
												)}
											</>
										)}
									</div>
									{/* <button
								className="ascent-button ascent-button--header-buttons ascent-button--primary"
								onClick={handleSubmit}
								disabled={selectedSubVendor.length == 0}
							>
								Save
							</button> */}
								</div>
							</div>
							<div className="footer-wrapper-new w-100">
								<img
									src="/images/footer-image.svg"
									className="img-fluid footer-image"
								/>
							</div>
						</div>
					</>
				)}

				<div className="map-vendor-wrapper map-vendor-wrapper--vendor w-100 pt-5">
					<div className="map-vendor__details d-flex align-items-flex-start p-0">
						<div className="map-vendor__search map-vendor__search--vendor">
							<div
								className="map-vendor__search-form mb-3 position-relative"
								style={{ width: "500px" }}
							>
								<SearchableDropdownSelect
									placeholder={"Search Vendor"}
									options={vendorsList}
									searchLoading={searchLoading}
									handleChange={(val: any) => handleTriggerAPI(val)}
									handleClick={handleClick}
									value={selectedValue}
									label="label"
									id="id"
									className="custom"
								/>
			
							</div>
						</div>
					</div>

					<h5 className="map-vendor__search-title">Assigned Vendor</h5>
						{isLoading ? (
						<Loader />
						) : getValue(selectedSubVendor, `length`, 0) > 0 ? (
						<>
							<div className="vendor-location-mapping-table">
								<ScrollableDataTable
								columns={columns}
								data={selectedSubVendor}
								checkboxlogo
								getTableState={getTableState}
								rowClick={rowClick}
								check={check}
								selectedIDs={selectedIDs}
								getTrProps={getTrProps}
								/>
							</div>
						</>
						) : (
						<>
							{Object.keys(urlParams).length !== 0 ? (
							<>
								<Notfound />
							</>
							) : (
							<Notfound />
							)}
						</>
						)}
				</div>

				<DeleteModal
					isOpen={isDelete}
					handleModal={handleDelete}
					handleSubmit={handleDeleteFunction}
					deleteValue={deleteValue}
				/>
			</Layout>
		</>
	);
}
